import { useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/lp/portal/resident/ged`;
export const BAND = {
  red: { label: "Foundational Review Needed", cls: "bg-red-500/15 border-red-400 text-red-200", bar: "bg-red-500" },
  yellow: { label: "Close to Passing", cls: "bg-amber-400/15 border-amber-300 text-amber-100", bar: "bg-amber-400" },
  green: { label: "Likely to Pass", cls: "bg-emerald-500/15 border-emerald-400 text-emerald-100", bar: "bg-emerald-500" },
};
export const bigBtn = "w-full min-h-[56px] rounded-xl bg-[#d4a017] text-black text-lg font-bold px-5 py-3 active:scale-[0.98] transition-transform disabled:opacity-40";
export const choiceBtn = "w-full min-h-[56px] rounded-xl border-2 px-4 py-3 text-left text-base font-medium transition-colors";
export const gcard = "rounded-2xl border border-white/15 bg-white/[0.04] p-5";

/** Soft male narration for the GED Pathway; one clip at a time, mute remembered on this device. */
export function useGedVoice(token) {
  const ref = useRef(null);
  const [muted, setMuted] = useState(() => localStorage.getItem("ged_muted") === "1");
  useEffect(() => () => ref.current?.pause(), []);
  const play = (key) => {
    ref.current?.pause();
    if (muted) return;
    const a = new Audio(`${API}/audio/${encodeURIComponent(key)}?token=${encodeURIComponent(token)}`);
    ref.current = a;
    a.play().catch(() => {});
  };
  const toggle = () => { const m = !muted; setMuted(m); localStorage.setItem("ged_muted", m ? "1" : "0"); if (m) ref.current?.pause(); };
  return { play, muted, toggle };
}
